import {charcoal} from '../../sass/v2/_exports.sass';

export const NumberedListIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Numbered list</title>
      <path
        d="M4.66667 28.6667V27.0771H8V25.6667H6.00001V24.0769H8V22.6667H4.66667V21.0769H8.46167C8.78123 21.0769 9.04911 21.1851 9.26534 21.4013C9.48156 21.6176 9.58967 21.8855 9.58967 22.2051V23.7949C9.58967 24.1145 9.48156 24.3824 9.26534 24.5987C9.04911 24.8149 8.78123 24.9231 8.46167 24.9231C8.78123 24.9231 9.04911 25.0311 9.26534 25.2473C9.48156 25.4636 9.58967 25.7316 9.58967 26.0513V27.5384C9.58967 27.8581 9.48156 28.1261 9.26534 28.3424C9.04911 28.5585 8.78123 28.6667 8.46167 28.6667H4.66667ZM4.66667 19.7951V16.3333C4.66667 16.0137 4.77478 15.7457 4.991 15.5293C5.20723 15.3131 5.47523 15.2051 5.79501 15.2051H8V13.7949H4.66667V12.205H8.46167C8.78123 12.205 9.04911 12.3131 9.26534 12.5293C9.48156 12.7458 9.58967 13.0138 9.58967 13.3333V15.6667C9.58967 15.9863 9.48156 16.2543 9.26534 16.4707C9.04911 16.6869 8.78123 16.7951 8.46167 16.7951H6.25634V18.2051H9.58967V19.7951H4.66667ZM6.66667 10.923V4.92301H4.66667V3.33334H8.25634V10.923H6.66667ZM12.4103 25V23H27.3333V25H12.4103ZM12.4103 17V15H27.3333V17H12.4103ZM12.4103 9.00001V7.00001H27.3333V9.00001H12.4103Z"
        fill={color}
      />
    </svg>
  );
};
